import { hashCodeq5arwsb9dgti as hashCode } from '../js/coreRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { AbstractCollection1g9uvtcheckwb as AbstractCollection } from './AbstractCollection.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from './Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../js/typeCheckUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      d8(c) {
        var hashCode_0 = 0;
        var _iterator__ex2g4s = c.p1();
        while (_iterator__ex2g4s.q1()) {
          var element = _iterator__ex2g4s.r1();
          var tmp = hashCode_0;
          var tmp1_elvis_lhs = element == null ? null : hashCode(element);
          hashCode_0 = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
        }
        return hashCode_0;
      }
      c8(c, other) {
        if (!(c.q2() === other.q2()))
          return false;
        return c.q4(other);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var AbstractSetClass;
function AbstractSet() {
  if (AbstractSetClass === VOID) {
    class $ extends AbstractCollection() {
      static hj($box) {
        return this.n6($box);
      }
      equals(other) {
        if (other === this)
          return true;
        if (!(!(other == null) ? isInterface(other, KtSet()) : false))
          return false;
        return Companion_instance.c8(this, other);
      }
      hashCode() {
        return Companion_instance.d8(this);
      }
    }
    initMetadataForClass($, 'AbstractSet', VOID, VOID, [KtSet()]);
    AbstractSetClass = $;
  }
  return AbstractSetClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance2zu9ihjme26ha,
  AbstractSet as AbstractSet2mw1ev10zm1bz,
};
//endregion

//# sourceMappingURL=AbstractSet.mjs.map
